module.exports = __webpack_public_path__ + "img/h&s4.6a308599.jpeg";